import { doc, updateDoc, increment } from 'firebase/firestore';
import { db } from '../services/firebaseConfig';

// --- CONSTANTES Y ESTÉTICA ---
export const ADMIN_EMAILS = [
  'cmagustinbonventre843@gmail.com',
  'soporteacaargentina@gmail.com'
].map(email => email.toLowerCase());

export const isUserAdmin = (u) => u?.email && ADMIN_EMAILS.includes(u.email.toLowerCase());

export const normalizeText = (t) => t ? t.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase() : '';

export const CATEGORY_IMAGES = {
  'Restaurantes & Cafés': 'https://images.unsplash.com/photo-1554118811-1e0d58224f24?auto=format&fit=crop&w=800&q=80',
  'Comidas al Paso': 'https://images.unsplash.com/photo-1561758033-d89a9ad46330?auto=format&fit=crop&w=800&q=80',
  'Mercados & Sabores': 'https://images.unsplash.com/photo-1534723452862-4c874018d66d?auto=format&fit=crop&w=800&q=80',
  'Hogar & Construcción': 'https://images.unsplash.com/photo-1620626011761-996317b8d101?auto=format&fit=crop&w=800&q=80',
  'Muebles & Deco': 'https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&w=800&q=80',
  'Moda & Accesorios': 'https://images.unsplash.com/photo-1441984904996-e0b6ba687e04?auto=format&fit=crop&w=800&q=80',
  'Diseño & Regalos': 'https://images.unsplash.com/photo-1513519245088-0e12902e5a38?auto=format&fit=crop&w=800&q=80',
  'Salud & Belleza': 'https://images.unsplash.com/photo-1560066984-138dadb4c035?auto=format&fit=crop&w=800&q=80',
  'Profesionales & Oficios': 'https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=800&q=80',
  'Mascotas & Veterinarias': 'https://images.unsplash.com/photo-1583337130417-3346a1be7dee?auto=format&fit=crop&w=800&q=80',
  'Autos & Talleres': 'https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?auto=format&fit=crop&w=800&q=80'
};

export const RATING_TEXTS = { 1: 'Muy Malo 😠', 2: 'Malo 😕', 3: 'Bueno 😐', 4: 'Muy Bueno 🙂', 5: 'Excelente 😍' };

// --- LÓGICA DE NEGOCIO ---
export const checkIsOpen = (open, close) => {
  if (!open || !close) return false;
  const now = new Date();
  const current = now.getHours().toString().padStart(2, '0') + ':' + now.getMinutes().toString().padStart(2, '0');
  return open <= close ? (current >= open && current <= close) : (current >= open || current <= close);
};

// CORRECCIÓN CLAVE: Agregamos "!biz" al principio para evitar que crashee si el local aún no cargó.
export const isPremiumActive = (biz) => {
  if (!biz || !biz.paymentDate || !biz.premiumUntil) return false;
  const now = new Date();
  return now <= new Date(biz.premiumUntil);
};

export const sanitizeUrl = (url) => {
  if (!url) return '';
  try { return new URL(url).toString(); } catch (e) { return ''; }
};

export const buildGoogleMapsUrl = (address, city) => {
  if (!address) return '#';
  return `https://www.google.com/maps/search/?api=1&query=$${encodeURIComponent(address + ', ' + (city || ''))}`;
};

export const validateBusinessData = (data) => {
  const errors = [];
  if (!data.name || data.name.trim() === '') errors.push("El nombre es obligatorio");
  if (!data.phone || data.phone.trim() === '') errors.push("El número de WhatsApp es obligatorio");
  return errors;
};

export const handleFirestoreError = (error, showToast) => {
  console.error("Firebase Error:", error);
  showToast(error.message || "Ocurrió un error. Intentá de nuevo.", "error");
};

// --- ANALYTICS Y TRACKERS ---
export const trackClick = async (type, bizId) => {
  try {
    const bizRef = doc(db, 'businesses', bizId);
    await updateDoc(bizRef, { [`clicks.${type}`]: increment(1) });
  } catch (e) { console.error("Error tracking click", e); }
};

export const trackProfileView = async (bizId) => {
  try {
    const bizRef = doc(db, 'businesses', bizId);
    await updateDoc(bizRef, { profileViews: increment(1) });
  } catch (e) { console.error("Error tracking view", e); }
};

export const reportReview = (reviewId, bizId, userId, showToast) => {
  showToast("Reseña reportada para revisión del administrador.", "success");
};